import { DeviceIdService } from "@service/device-id.service";

const BASE_API_URL = process.env.REACT_APP_API_URL;

export class TokenRefreshServiceService {
  public static instance = new TokenRefreshServiceService();
  private deviceIdService = DeviceIdService.instance;

  private constructor() {}

  async refreshToken(accessToken: string): Promise<{ accessToken: string }> {
    const deviceId = this.deviceIdService.getDeviceId();

    const res = await fetch(`${BASE_API_URL}/users/token/refresh?`, {
      method: "POST",
      headers: {
        "content-type": "application/json",
      },
      body: JSON.stringify({
        deviceId,
        accessToken,
      }),
    });
    return res.json();
  }
}
